import { Component } from '@angular/core';

@Component({
  selector: 'app-badge-nested-demo',
  templateUrl: './badge-nested-demo.component.html',
  styleUrls: ['./badge-nested-demo.component.scss'],
})
export class BadgeNestedDemoComponent {}
